<template>
  <div>
    <list :listTitle="$t('task.label')" :loading="loading || loadingFilters" :total="toolBatchTaskTotalTasks" :typesListAvailable="['displayList']" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'desc' }" @change="onChange" @clearFilters="clearFilters">
      <span class="btn btn--info" slot="header-actions" @click="createTask">{{ $t('task.create.label') }}</span>
      <template slot="filters">
        <form-group label="Status">
          <select v-model="options.status" class="form-select">
            <option :value=null>Todos</option>
            <option v-for="status in toolBatchTaskStatuses" :key="status" :value="status">{{ $t(`batch.statuses.${status}.label`) }}</option>
          </select>
        </form-group>
        <form-group label="Ação">
          <select v-model="options.identifier" class="form-select">
            <option :value=null>Todas</option>
            <option v-for="action in toolBatchTaskActions" :value="action.identifier" :key="action">{{ action.label }}</option>
          </select>
        </form-group>
        <form-group label="Módulo">
          <select v-model="moduleSelected" class="form-select">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option :value="`${module.type}.${module.identifier}`" v-for="module in toolBatchTaskModules">
              {{ $t(`${module.type}.label`) }} {{ $t(`${module.identifier}.label`) }}
            </option>
          </select>
        </form-group>
      </template>
      <div class="l-col-12@md" v-for="(task, index) in toolBatchTaskTasks" :key="index">
        <task-card :task="task">
          <li class="c-nav__item">
            <a role="button" class="c-nav__link" :class="{ 'is-disabled': task.status !== 'pending' }" @click="showModal(task)">Cancelar</a>
          </li>
        </task-card>
      </div>
      <div class="l-col u-textCenter" v-if="!toolBatchTaskTasks.length">
        <panel>
          Nenhuma tarefa encontrada.
        </panel>
      </div>

      <modal-cancel v-model="cancelItemFlag" v-on:option="cancelTask(cancelItem)"/>
    </list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import List from '@/components/shared/list/Paginator'
  import FormGroup from '@/components/template/FormGroup'
  import TaskCard from '@/components/tool/batch/TaskCard'
  import Panel from '@/components/template/Panel'
  import ModalCancel from '@/components/Task/ModalCancel'

  export default {
    data: () => ({
      options: {
        status: null,
        identifier: null,
        moduleType: null,
        moduleIdentifier: null
      },
      moduleSelected: null,
      loading: false,
      loadingFilters: false,
      sortFields: [
        'date.created'
      ],
      cancelItemFlag: false,
      cancelItem: null
    }),
    async mounted () {
      this.loadingFilters = true

      Promise.all([
        this.fetchModules(),
        this.fetchStatuses(),
        this.fetchActions()
      ])
        .then(() => {})
        .catch(() => {})
        .finally(() => { this.loadingFilters = false })
    },
    methods: {
      ...mapActions('toolBatchTask', [
        'fetchModules',
        'fetchActions',
        'fetchStatuses',
        'fetchTasks',
        'clearActions',
        'cancelTask'
      ]),
      async onChange (options) {
        this.loading = true

        merge(this.options, options)

        await this.fetchTasks({ options: this.options })

        this.loading = false
      },
      createTask () {
        return this.$router.push('/tool/batch/tasks/create')
      },
      showModal (task) {
        if (task.status !== 'pending') {
          return false
        }
        this.cancelItem = task

        this.cancelItemFlag = true
      },
      clearFilters () {
        this.moduleSelected = null
      }
    },
    computed: {
      ...mapFields({
        toolBatchTaskActions: 'toolBatchTask.actions',
        toolBatchTaskStatuses: 'toolBatchTask.statuses',
        toolBatchTaskTotalTasks: 'toolBatchTask.totalTasks',
        toolBatchTaskTasks: 'toolBatchTask.tasks',
        toolBatchTaskModules: 'toolBatchTask.modules'
      })
    },
    watch: {
      moduleSelected (value) {
        if (value === null) {
          return false
        }

        const [type, identifier] = value.split('.')
        this.options.moduleType = type
        this.options.moduleIdentifier = identifier
      }
    },
    components: {
      List,
      FormGroup,
      TaskCard,
      Panel,
      ModalCancel
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// List.vue?39e4be60